// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Space, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import YoutubeFrame from '../../Atoms/YoutubeFrame';
import CreateEventIcon from './CreateEventIcon';

const EventsNotFound: FC<{ totalCount: number }> = ({ totalCount }) => (
  <Stack>
    <Box sx={(theme) => ({ width: '100%', height: 50, backgroundColor: theme.colors.gray[0], borderRadius: 10 })} />
    {totalCount === 0 && <YoutubeFrame embedId="LWrR8t6MbzQ?si=hsqB8c4L5gCooHMs" />}
    <Box sx={(theme) => ({ width: '100%', height: 100, backgroundColor: theme.colors.gray[0], borderRadius: 10 })} />
    {totalCount === 0 ? (
      <Text sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
        Du hast noch kein Event erstellt. Klicke auf
        <Space w={5} />
        <CreateEventIcon />
        <Space w={2} />, um zu beginnen.
      </Text>
    ) : (
      <Text align="center">
        Die Kombination der ausgewählten <b>Filter</b> erzielt keine Ergebnisse.
      </Text>
    )}
  </Stack>
);

export default EventsNotFound;
